import * as React from "react";
import { IconProps } from "./types";

export const Minimize01Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(Minimize01Icon as React.FunctionComponent).displayName = "Minimize01Icon";

export default Minimize01Icon;
